export const MARGIN = { top: 0, right: 10, bottom:-30 , left: 0 };

export const COLOR_LEGEND_HEIGHT = 0;

export const COLORS = [
  "#5DADEC",
  "#A8D0F0",
  "#FFFFFF",
  "#E0A5A6",
  "#CE5757",
  // "#5DADEC",
  // "#A8D0F0",
  // "#F2F3F4",
  // "#E0A5A6",
  // "#CE5757",
  // "#B34242",
];

export const THRESHOLDS = [
  0.2 , 0.4 ,0.5, 0.6, 0.8
];
